import Route from '@ember/routing/route';
import { ajax } from 'discourse/lib/ajax';

export default class AdminPluginsProxyviewsBenchmarksRoute extends Route {
  async model() {
    // allSettled so the runs list still loads if the alerts endpoint fails
    // (e.g. alerts table not yet migrated on an older install).
    const [runsResult, providersResult, alertsResult] = await Promise.allSettled([
      ajax('/admin/plugins/proxyviews-benchmarks/runs'),
      ajax('/admin/plugins/proxyviews-directory/networks'),
      ajax('/admin/plugins/proxyviews-benchmarks/alerts', { data: { page: 1 } }),
    ]);

    const runsData = runsResult.status === 'fulfilled' ? runsResult.value : { benchmark_runs: [], meta: {} };
    const alertsData = alertsResult.status === 'fulfilled' ? alertsResult.value : { alerts: [], meta: {} };

    // Full provider list for the "provider" picker on the new-run form.
    let allProviders = [];
    if (providersResult.status === 'fulfilled') {
      allProviders = (providersResult.value.providers || [])
        .map((raw) => raw.provider || raw)
        .map((p) => ({ id: p.id, name: p.name, slug: p.slug }));
    }

    return {
      runs: runsData.benchmark_runs || [],
      meta: runsData.meta || {},
      allProviders,
      alerts: alertsData.alerts || [],
      alertsMeta: alertsData.meta || {},
    };
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.runs = model.runs || [];
    controller.meta = model.meta || {};
    controller.page = model.meta?.page || 1;
    controller.allProviders = model.allProviders || [];
    controller.alerts = model.alerts || [];
    controller.alertsMeta = model.alertsMeta || {};
    controller.alertsPage = model.alertsMeta?.page || 1;
  }
}
